<template>
  <div id="school">
    <div class="content">
        <div class="title"><span @click="goback" style="color:#c30d23;cursor:pointer;">学员管理</span> / {{student_name}}</div>
        <div class="botBox">
            <div class="fl_left codeBox">
                <div class="sessionTop">
                    <img :src="item.user_info.avater" alt="" style="width: 68px;margin:0 auto;">
                    <div style="font-size: 14px;color: #333;margin-top: 5px;">{{item.user_info.name}}</div>
                    <div style="font-size: 13px;color: #666;margin-top: 5px;">{{item.user_info.phone}}</div>
                </div>
                <div class="sessionBot">
                    <div class="list">
                        <div class="fl_left urlName">性别</div>
                        <div class="fl_left urlDeal" v-if="item.user_info.sex==1">男</div>
                        <div class="fl_left urlDeal" v-else>女</div>
                        <div class="clear"></div>
                    </div>
                    <div class="list">
                        <div class="fl_left urlName">出生日期</div>
                        <div class="fl_left urlDeal">{{item.user_info.birthday}}</div>
                        <div class="clear"></div>
                    </div>
                    <div class="list">
                        <div class="fl_left urlName">证件号</div>
                        <div class="fl_left urlDeal">{{item.user_info.card_code}}</div>
                        <div class="clear"></div>
                    </div>
                    <!-- <div class="list">
                        <div class="fl_left urlName">身份证件</div>
                        <div class="fl_left urlDeal">
                            <img :src="item.user_info.sfImg1" alt="">
                            <img :src="item.user_info.sfImg2" alt="">
                        </div>
                        <div class="clear"></div>
                    </div> -->
                </div>
            </div>
            <div class="fl_right urlBox borderBox">
                <div style="line-height: 50px;border-bottom: 1px solid #e6e6e6;text-indent: 20px;">
                    <div class="wzbarBox">
                        <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                            <div>{{name.name}}</div>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div style="border:1px solid #e6e6e6;box-sizing: border-box;">
                        <Table :columns="columns7" :data="item.class_history" v-if="num==0"></Table>
                        <Table :columns="columns8" :data="item.course_history" v-else></Table>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'school',
      data () {
        return {
            items:[
                {name:'考级记录',id:0},
                {name:'课件授权',id:1},
            ],
            file_url:'',
            file_name:'',
            file_urls:'',
            file_names:'',
            sesImg:'',
            sesName:'张小北',
            sesPhone:'15035165236',
            sfImg1:'',
            sfImg2:'',
            columns7: [
                {
                    title: '培训期次',
                    align: 'center',
                    key: 'term_name',
                },
                {
                    title: '舞种',
                    align: 'center',
                    key: 'dance_name',
                },
                {
                    title: '级别',
                    align: 'center',
                    key: 'level',
                },
                {
                    title: '班级',
                    align: 'center',
                    key: 'class_name',
                },
                {
                    title: '上课时间',
                    align: 'center',
                    key: 'date_show',
                    /*render: (h, params) => {
                        return h('div',{},params.row.start_date+'-'+params.row.end_date);
                    }*/
                },
                {
                    title: '状态',
                    align: 'center',
                    key: 'status',
                    width:90,
                    render: (h, params) => {
                        if(params.row.status==1){
                            return h('div',{
                                style:{
                                    color:'green',
                                }
                            },'已考');
                        }
                        else if(params.row.status==0){
                            return h('div',{
                                style:{
                                    color:'#999',
                                }
                            },'未考');
                        }
                    }
                },
                {
                    title: '成绩',
                    align: 'center',
                    key: 'achievement',
                    width:90,
                    render: (h, params) => {
                        if(params.row.achievement==1){
                            return h('div',{
                                style:{
                                    color:'green',
                                }
                            },'优秀');
                        }
                        else if(params.row.achievement==0){
                            return h('div',{
                                style:{
                                    color:'#999',
                                }
                            },'暂无');
                        }
                        else if(params.row.achievement==2){
                            return h('div',{
                                style:{
                                    color:'green',
                                }
                            },'良好');
                        }
                        else if(params.row.achievement==3){
                            return h('div',{
                                style:{
                                    color:'green',
                                }
                            },'合格');
                        }
                        else if(params.row.achievement==4){
                            return h('div',{
                                style:{
                                    color:'#dc4e5c',
                                }
                            },'不合格');
                        }
                    }
                },
            ],
            columns8: [
                {
                    title: '名称',
                    align: 'center',
                    key: 'issue_name',
                    render: (h, params) => {
                        return h('div',{},params.row.dance_name+params.row.level+params.row.issue_name);
                    }
                },
                {
                    title: '支付金额',
                    align: 'center',
                    key: 'money',
                },
                {
                    title: '购买时间',
                    align: 'center',
                    key: 'pay_time',
                },
                {
                    title: '过期时间',
                    align: 'center',
                    key: 'expire_date',
                },
            ],
            data6: [],
            student_id:'',
            student_name:'',
            item:{
                user_info:{
                    avater:''
                }
            },
            num:0,
        }
      },
      methods:{
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.getUrl();
            },
            goback(){
                this.$router.go(-1);
            },
            getUrl(){
                let _this=this;
                _this.$axios.post('getuserhistorylist',{user_id:_this.student_id}).then(res=>{
                    if(res.data.code==200){
                        _this.item=res.data.data;
                    }
                }).catch( function(response) {
                    console.log(response)
                });
            }
      },
      created(){
          let _this=this;
          this.$store.dispatch('changeNav',this.$route.query.changeNav);
          _this.student_id=this.$route.query.student_id;
          _this.student_name=this.$route.query.student_name;
          _this.getUrl();
      }
    }
</script>

<style scoped>
    .wzbarBox{
       width: 200px; 
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;      
      flex-direction:column;
      align-items:flex-end;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #fff;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .showBox{
        position: absolute;
        top:55px;
        right: -9px;
        padding: 15px 30px;
        box-sizing: border-box;
    }
    .shinput{
        width: 230px;
        height: 36px;
        background-color: #f5f5f5;
        border-radius: 4px;
        border: solid 1px #dddddd;
        margin-bottom: 16px;
    }
    .topBox{
        width: 100%;
        height: 70px;
        line-height: 70px;
        color: #333;
        background-color: #fff;
        margin-bottom: 20px;
        padding: 0 28px;
        box-sizing: border-box;
    }
    .title{
        line-height: 58px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        overflow: hidden;
        /*padding:40px 63px 70px;*/
        min-height: 686px;
        position: relative;
    }
    .codeBox{
        width: 26%;
        min-height: 770px;
        background-color: #ffffff;
        border: solid 1px #e7e7eb;
        /*margin-right: 20px;*/
    }
    .sessionTop{
        border-bottom: 1px solid #e6e6e6;
        text-align: center;
        padding: 24px 0 16px;
    }
    .urlBox{
        width: 72%;
        background-color: #fff;
        min-height: 770px;
        border: solid 1px #e7e7eb;
    }
    .sessionBot{
        padding: 0 14px;
        box-sizing: border-box;
        width: 280px;
        margin: 0 auto;
    }
    .list{
        overflow: hidden;
        margin-top: 15px;
    }
    .urlName{
        font-size: 14px;
        color: #999;
        width: 82px;
        text-align: right;
        padding-right: 15px;
    }
    .urlDeal{
        font-size: 14px;
        color: #333;
    }
    .urlDeal>img{
        width: 140px;
        margin-bottom: 13px;
    }
    .bottom{
        padding: 17px;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/user_mager/stuList.vue